module.exports = __webpack_public_path__ + "static/media/img3-3.3271663f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/nutricheck_foliar/FE/img3-3.png
// module id = 2239
// module chunks = 3